import { StoreActions } from '@elentari/core/types'
import makeGlobal from '@elentari/core/utils/makeGlobal'
import { CenarioMetadataResponse } from '../types'
import { fetchCenarioMetadata } from './cenariosRepository'

interface State {
  metadata: CenarioMetadataResponse | null
  loading: boolean
}

interface Actions {
  fetchIfNeeded: () => void
}

const initialState: State = {
  metadata: null,
  loading: false
}

const actions: StoreActions<State, Actions> = {
  fetchIfNeeded: store => async () => {
    if (store.state.metadata || store.state.loading) {
      return
    }

    store.setState({ ...store.state, loading: true })

    const response = await fetchCenarioMetadata()

    store.setState({
      metadata: response.ok && response.data ? response.data : null,
      loading: false
    })
  }
}

export const useCenarioMetadata = makeGlobal<State, Actions>(
  initialState,
  actions
)
